import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { AssessmentSlotBooking } = await import('./index');
    return {
        Component: AssessmentSlotBooking,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
